import React, { useState } from "react";
import SearchBar from "../../atoms/SearchButton";
import FilterDialogBox from "../FilterDialogBox";
import Button from "../../atoms/Button";
import { ReactComponent as Filter } from "../../svgs/Filterr.svg";

const SearchFilterHeader = ({
  heading,
  seeAllUser = false,
  searchItem,
  setSearchItem,
  filterData,
  setFilterData
}) => {
  // const [searchItem, setSearchItem] = useState("");
  const [isFilterDialogOpen, setFilterDialogOpen] = useState(false);
  const [selectedRegistry, setSelectedRegistry] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProjectVintage, setSelectedProjectVintage] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);
  const [selectedCreditType, setSelectedCreditType] = useState(null);
  const [selectedTypeOfTransaction, setSelectedTypeOfTransaction] =
    useState(null);
  const [lowPrice, setLowPrice] = useState("0");
  const [highPrice, setHighPrice] = useState("50");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedUserType, setSelectedUserType] = useState(null);

  const handleRegistryCheck = (e) => {
    {
      const selectedValue = e.target.value;
      setSelectedRegistry(selectedValue);
    }
  };

  const handleTokenCheck = (e) => {
    {
      const selectedToken = e.target.value;
      setSelectedToken(selectedToken);
    }
  };

  const handleCreditType = (e) => {
    {
      const selectedCreditType = e.target.value;
      setSelectedCreditType(selectedCreditType);
    }
  };

  const handleTypeOfTransaction = (e) => {
    const selectedTypeOfTransaction = e.target.value;
    setSelectedTypeOfTransaction(selectedTypeOfTransaction);
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setSelectedCategory(selectedCategory);
  };

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    setSelectedCountry(selectedCountry);
  };

  const handleProjectVintageChange = (e) => {
    const selectedProjectVintage = e.target.value;
    setSelectedProjectVintage(selectedProjectVintage);
  };

  const handleTypeCheck = (e) => {
    const selectedValue = e.target.value;
    setSelectedType(selectedValue);
  };

  const handleUserTypeCheck = (e) => {
    const selectedValue = e.target.value;
    setSelectedUserType(selectedValue);
  };

  const handleFilterDialogClose = () => {
    setSelectedRegistry(null);
    setSelectedCategory(null);
    setSelectedProjectVintage(null);
    setSelectedToken(null);
    setSelectedCreditType(null);
    setSelectedCountry(null);
    setFilterData(null);
    setSelectedTypeOfTransaction(null);
    setFilterDialogOpen(false);
    setSelectedUserType(null);
    setSelectedUserType(null);
    setLowPrice("0");
    setHighPrice("50");
  };

  const handleFilterDialogSubmit = () => {
    setFilterDialogOpen(false);
    if (!seeAllUser) {
      setFilterData({
        registries: selectedRegistry ? [selectedRegistry] : null,
        categoryId: selectedCategory,
        country: selectedCountry,
        tokenTypes: selectedToken ? [selectedToken] : null,
        creditType: selectedCreditType,
        typeOfTransaction: selectedTypeOfTransaction,
        priceLow: lowPrice,
        priceHigh: highPrice
      });
    } else {
      setFilterData({
        type: selectedType ? selectedType : null,
        user_type: selectedUserType ? selectedUserType : null
      });
    }
  };

  const handleSearch = () => {
    // console.log(searchItem);
  };
  return (
    <div className="h-20 bg-white w-full flex justify-between items-center">
      <div>
        <h3 className="text-3xl  px-7 font-bold">{heading}</h3>
      </div>
      <div className="flex">
        <div className="px-4">
          <SearchBar
            onSearch={handleSearch}
            searchItem={searchItem}
            setSearchItem={setSearchItem}
            variant="secondaryxl"
            className="text-black w-[550px]"
            borderColor="border-none"
            placeholderColor="blue-800"
            inputBackground="blue"
            svgStrokeColor="blue"
            inputWidth="full"
            inputHeight="8"
          />
        </div>
        <div className="px-7">
          <Button
            varient="secondaryxl"
            borderColor="black"
            onClick={() => setFilterDialogOpen(true)}
            className="w-full focus-visible:outline-0 text-sm justify-center pl-4 pr-3 py-[0.5rem]  text-blue-800  bg-blue-200 sm:w-auto flex items-center"
          >
            Filter{" "}
            <span className="pl-8">
              <Filter />
            </span>
          </Button>
          {seeAllUser ? (
            <FilterDialogBox
              open={isFilterDialogOpen}
              onCancel={handleFilterDialogClose}
              onOk={handleFilterDialogSubmit}
              selectedType={selectedType}
              showProject={false}
              setSelectedType={setSelectedType}
              onCheckType={handleTypeCheck}
              selectedUserType={selectedUserType}
              onCheckUserType={handleUserTypeCheck}
            />
          ) : (
            <FilterDialogBox
              open={isFilterDialogOpen}
              onCancel={handleFilterDialogClose}
              onOk={handleFilterDialogSubmit}
              selectedRegistry={selectedRegistry}
              onCheckRegistry={handleRegistryCheck}
              selectedCategory={selectedCategory}
              onSelectCategory={handleCategoryChange}
              selectedProjectVintage={selectedProjectVintage}
              onSelectProjectVintage={handleProjectVintageChange}
              selectedToken={selectedToken}
              onChangeToken={handleTokenCheck}
              selectedCreditType={selectedCreditType}
              onSelectCreditType={handleCreditType}
              selectedCountry={selectedCountry}
              onSelectCountry={handleCountryChange}
              selectedTypeOfTransaction={selectedTypeOfTransaction}
              onSelectTypeOfTransaction={handleTypeOfTransaction}
              min={lowPrice} // Pass lowPrice to the dialog
              max={highPrice} // Pass highPrice to the dialog
              setLowPrice={setLowPrice} // Function to update lowPrice
              setHighPrice={setHighPrice}
              showProject={true}
              onCheckType={handleTypeCheck}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchFilterHeader;
